import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  employeesGroup: [],
}

export const mutations = {
  SET_EMPLOYEES_GROUP(state, employeesGroup) {
    state.employeesGroup = employeesGroup
  },
  ADD_EMPLOYEE_GROUP(state, employeeGroup) {
    state.employeesGroup.push(employeeGroup)
  },
  EDIT_EMPLOYEE_GROUP(state, employeeGroup) {
    const index = state.employeesGroup.findIndex(
      (e) => e.employee_group_uuid === employeeGroup.employee_group_uuid
    )
    if (index !== -1) {
      state.employeesGroup.splice(index, 1, employeeGroup)
    }
  },
  DELETE_EMPLOYEE_GROUP(state, employee_group_uuid) {
    const index = state.employeesGroup.findIndex(
      (e) => e.employee_group_uuid === employee_group_uuid
    )
    if (index !== -1) state.employeesGroup.splice(index, 1)
  },
}

export const actions = {
  fetchEmployeesGroup({ commit }, payload) {
    return ApiService.fetchEmployeesGroup(payload)
      .then((res) => {
        const employeesGroup = res.data.data
        commit('SET_EMPLOYEES_GROUP', employeesGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeeGroupById({ commit }, payload) {
    return ApiService.fetchEmployeeGroupById(payload)
      .then((res) => {
        const employeeGroup = res.data
        return employeeGroup
      })
      .catch((error) => {
        throw error
      })
  },
  addEmployeeGroup({ commit }, payload) {
    return ApiService.addEmployeeGroup(payload)
      .then((res) => {
        const employeeGroup = res.data
        commit('ADD_EMPLOYEE_GROUP', employeeGroup)
        return employeeGroup
      })
      .catch((error) => {
        throw error
      })
  },
  editEmployeeGroup({ commit }, payload) {
    return ApiService.editEmployeeGroup(payload)
      .then((res) => {
        const employeeGroup = res.data
        commit('EDIT_EMPLOYEE_GROUP', employeeGroup)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployeeGroup({ commit }, payload) {
    return ApiService.deleteEmployeeGroup(payload)
      .then(() => {
        commit('DELETE_EMPLOYEE_GROUP', payload.employee_group_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeesGroupMember({ commit }, payload) {
    return ApiService.fetchEmployeesGroupMember(payload)
      .then((res) => {
        const employeeGroupMember = res.data
        return employeeGroupMember
      })
      .catch((error) => {
        throw error
      })
  },
  addEmployeeGroupMember({ commit }, payload) {
    return ApiService.addEmployeeGroupMember(payload).catch((error) => {
      throw error
    })
  },
  deleteEmployeeGroupMember({ commit }, payload) {
    return ApiService.deleteEmployeeGroupMember(payload).catch((error) => {
      throw error
    })
  },
}
